module.exports = __webpack_public_path__ + "img/skyscraper.95cb95ab.jpg";